import * as React from 'react';

import { Box, Checkbox, Paper, SortDirection } from '@mui/material';
import CustomPaginationActionsTable from '../../../../components/TablePagination';
import PaginateDataModel from '../../../../Models/PaginateDataModel';

interface CrewLabourListComponentProps {
  handlePagination: (data: any, type: string) => void;
  handleStatus: (data: any, type: string) => void;
  search?: any;
  recordList: any[];
  selectedRecords: any[];
  totalRecords: number;
  paginate: PaginateDataModel;
  orderBy: string;
  order: SortDirection;
  handleOrderBy: (columnName: any) => void;
}
const CrewLabourListComponent: React.FC<CrewLabourListComponentProps> = ({
  handlePagination,
  handleStatus,
  recordList,
  selectedRecords,
  totalRecords,
  paginate,
  orderBy,
  order,
  handleOrderBy,
}) => {
  const columns: any[] = [
    {
      field: 'firstName',
      headerName: 'First Name',
      renderCell: (value: any, row: any) => (
        <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
          <Checkbox
            edge="start"
            checked={selectedRecords.includes(row.id)}
            tabIndex={-1}
            disableRipple
          />

          <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
            <small>{row.firstName}</small>
          </Box>
        </Box>
      ),
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
    },
  ];
  return (
    <Paper sx={{ width: '100%' }} className="mt-4">
      <CustomPaginationActionsTable
        rows={recordList}
        columns={columns}
        totalRecords={totalRecords}
        handlePagination={(data) => {
          handlePagination(data, 'labour');
        }}
        handleRowClick={(row) => {
          console.log('row-clicked');
          //   navigate('/data-management/labour/' + row.id);
          //console.log(data);
        }}
        paginationModel={{
          page: paginate.offset,
          pageSize: paginate.limit,
        }}
        handleStatus={(data: any) => {
          handleStatus(data, 'labour');
        }}
        handleOrderBy={handleOrderBy}
        orderBy={orderBy}
        order={order}
      />
    </Paper>
  );
};
export default CrewLabourListComponent;
